import { render } from "./SectionSeven.vue?vue&type=template&id=249d6050&scoped=true"
const script = {}

import "./SectionSeven.vue?vue&type=style&index=0&id=249d6050&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249d6050"]])

export default __exports__